import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';
import { BumpModule, BumpModuleGroup } from '@games/entities';
import { IBumpModule, IBumpModuleGroup } from '@games/interfaces';

@Injectable({
  providedIn: 'root',
})
export class BumpService {
  constructor(private http: HttpClient) {}

  getBumpModuleGroups(courseId: number, gameId: number) {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/bump_module_groups/`)
      .pipe(
        map((bumpModuleGroups: IBumpModuleGroup[]) =>
          bumpModuleGroups.map(
            (bumpModuleGroup: IBumpModuleGroup) => new BumpModuleGroup(bumpModuleGroup)
          )
        )
      );
  }

  getBumpModule(
    courseId: number,
    gameId: number,
    moduleId: number,
    filters: HttpParams | { [params: string]: string | string[] } = {}
  ) {
    return this.http
      .get<any>(`${environment.apiUrl}courses/${courseId}/games/${gameId}/bumps/${moduleId}/`, {
        params: filters,
      })
      .pipe(map((bumpModule: IBumpModule) => new BumpModule(bumpModule)));
  }

  updateBumpModule(courseId: number, gameId: number, moduleId: number, modifiedBumpModule: any) {
    return this.http.post<any>(
      `${environment.apiUrl}courses/${courseId}/games/${gameId}/bumps/${moduleId}/`,
      modifiedBumpModule,
      { observe: 'response' }
    );
  }
}
